import type IconBuilder from '~/components/patterns/icons/builders/iconsData/IconBuilder';
import createIconBuilderFromCondUiKit from './condUiKitAdapter';


// cond-ui-kit icon data (from @conductor/cond-ui-kit/lib/components/icons/ProductIcon/IcoMoonData/chart-with-arrow.json)
const chartWithArrowIconData = {
	icon: {
		attrs: [{}, {}, {}],
		grid: 0,
		isMulticolor: false,
		isMulticolor2: false,
		paths: [
			'M948 208c0 24.301-19.699 44-44 44s-44-19.699-44-44v-116h-132c-24.301 0-44-19.7-44-44s19.699-44 44-44h160c33.138 0 60 26.863 60 60v144z',
			'M838.813 35.109c14.624-16.841 39.925-20.206 58.547-7.078 18.618 13.127 23.957 38.084 13.014 57.516l-2.406 3.812c-178.558 253.281-510.493 393.034-764.968 434.077-23.988 3.867-46.568-12.448-50.437-36.437-3.866-23.989 12.449-46.568 36.437-50.437 241.523-38.957 547.2-171.206 707.032-397.923l2.781-3.531z',
			'M192 936v88h-64v-88h64zM544 936v88h-64v-88h64zM896 936v88h-64v-88h64zM904 928v-448c0-4.418-3.582-8-8-8h-64c-4.418 0-8 3.582-8 8v448c0 4.418 3.582 8 8 8v88c-53.019 0-96-42.981-96-96v-448c0-53.019 42.981-96 96-96h64c53.019 0 96 42.981 96 96v448c0 53.019-42.981 96-96 96v-88c4.418 0 8-3.582 8-8zM552 928v-272c0-4.418-3.582-8-8-8h-64c-4.418 0-8 3.582-8 8v272c0 4.418 3.582 8 8 8v88c-53.019 0-96-42.981-96-96v-272c0-53.019 42.981-96 96-96h64c53.019 0 96 42.981 96 96v272c0 53.019-42.981 96-96 96v-88c4.418 0 8-3.582 8-8zM200 928v-128c0-4.418-3.582-8-8-8h-64c-4.418 0-8 3.582-8 8v128c0 4.418 3.582 8 8 8v88c-53.019 0-96-42.981-96-96v-128c0-53.019 42.981-96 96-96h64c53.019 0 96 42.981 96 96v128c0 53.019-42.981 96-96 96v-88c4.418 0 8-3.582 8-8zM888 4c33.138 0 60 26.863 60 60v144c0 24.301-19.699 44-44 44s-44-19.699-44-44v-57.422c-185.659 214.75-483.832 335.252-717 372.859-22.489 3.626-43.743-10.486-49.5-32.030l-0.937-4.406c-3.866-23.989 12.449-46.568 36.437-50.437 221.907-35.794 497.954-150.352 665.298-344.563h-66.298c-24.301 0-44-19.7-44-44s19.699-44 44-44h160z',
		],
		tags: ['chart with arrow'],
	},
	attrs: [{}, {}, {}],
	properties: {
		code: 59769,
		id: 14,
		name: 'chart-with-arrow',
		order: 3443,
		prevSize: 20,
	},
	setIdx: 0,
	setId: 2,
	iconIdx: 0,
};

// Create IconBuilder from cond-ui-kit data
const PerformanceIconBuilder: IconBuilder = createIconBuilderFromCondUiKit(
	chartWithArrowIconData as any,
	'#89c32e', // Default green color for new navigation
);

export default PerformanceIconBuilder;
